import classNames from 'classnames';
import styles from './ScommesseTitle.module.scss';

export type ScommesseTitleProps = {
  children: React.ReactNode;
  className?: string;
};

export const ScommesseTitle = ({ children, className }: ScommesseTitleProps) => {
  return <h3 className={classNames(styles.text, className ?? '')}>{children}</h3>;
};
